import { EProjectSection, trackEventV2 } from '../trackEventV2';
import { EFeedbackEventName, IFeedbackCTASelectedEvent } from './types';

export { EFeedbackEventSource } from './types';

export const trackFeedbackCTASelectedEvent = (event: IFeedbackCTASelectedEvent) => {
  trackEventV2(EFeedbackEventName.FEEDBACK_CTA_SELECTED, EProjectSection.MARKETPLACE, { ...event });
};
